export default "__VITE_ASSET__sP7PXOIZ__";